import type { RouteRecordRaw } from "vue-router"

export const FloorDecorRoutes: RouteRecordRaw[] = [
  {
    path: "floordecor",
    children: [
      {
        name: "floor-decor-start",
        path: "start",
        component: () => import("./pages/FloorDecorStartApplyPage.vue"),
        meta: {
          stepper: {
            visible: false,
          },
        },
      },
    ],
  },
]
